import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=dd8db91c&"
import script from "./Unauthorized.ts?vue&type=script&lang=ts&"
export * from "./Unauthorized.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports